// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "75f4106c3dce5d2ebbd5" + ".css";
};